import { signIn } from "core/store/actions/UserActions";
import { connect } from "react-redux";
import WebLoginPresentation from "./WebLoginPresentation";

const mapDispatchToProps = {
  dispatchSignIn: signIn
};

export const WebLogin = connect(null, mapDispatchToProps)(WebLoginPresentation);
